export default __webpack_public_path__ + "static/media/hero-leaves.f40860aa.png";